// Base Vue library
import Vue from 'vue';
import VueRouter from 'vue-router';
// Shared libs
import { formatDate } from 'wc-lib';

// Helpers
import { configurePageDomain } from './helpers/environment';
//import './helpers/iframeResizer.contentWindow.min';

// Custom application code below
import { App } from './app';
import { DistributionOfUnservedEnergy } from './views/electricity/nem/mtpasa/distribution-of-unserved-energy';
import { EstimatedUnservedEnergy } from './views/electricity/nem/mtpasa/estimated-unserved-energy';
import { MonthlyUnservedEnergy } from './views/electricity/nem/mtpasa/monthly-unserved-energy';
import { UnservedEnergyEvents } from './views/electricity/nem/mtpasa/unserved-energy-events';
import { SeverityAndFrequencyOfUnservedEnergy } from './views/electricity/nem/mtpasa/severity-and-frequency-of-unserved-energy';
import { SupplyAndDemandBreakdown } from './views/electricity/nem/mtpasa/supply-and-demand-breakdown';
import { InterconnectorCapacity } from './views/electricity/nem/mtpasa/interconnector-capacity';

// AEMO website home page
import { ElectricityDashboard } from './views/electricity/electricity-dashboard';
import { GasDashboard } from './views/gas/gas-dashboard';

// AEMO website visualisations
import { NemPriceAndDemand } from './views/electricity/nem/price-and-demand';
import { CumulativePrice } from './views/electricity/nem/cumulative-price';
import { NemAggregatedPriceAndDemandFiles } from './views/electricity/nem/aggregated-price-and-demand-files';
import { NemAveragePriceTables } from './views/electricity/nem/average-price-tables';
import { NemFuelMix } from './views/electricity/nem/fuel-mix';
import { NemDispatchOverview } from './views/electricity/nem/dispatch-overview/dispatch-overview';
import { DerSites } from './views/electricity/der/der-sites';
import { NemRenewablePenetration } from './views/electricity/nem/renewable-penetration/renewable-penetration';
import { FppFcasSummary } from './views/electricity/fpp/fpp-fcas-summary';
import { FppHistoricalPerformanceAndDcf } from './views/electricity/fpp/fpp-historical-performance-and-dcf';
import { FppCostRate } from './views/electricity/fpp/fpp-cost-rate';
import { FppFrequencyMeasure } from './views/electricity/fpp/fpp-frequency-measure';
import { FppResidual } from './views/electricity/fpp/fpp-residual';
import { FppRcrAndUsage } from './views/electricity/fpp/fpp-rcr-and-usage';

import '../styles/styles.scss';

// Set page domain to parent domain if in an iframe on the AEMO website
configurePageDomain();

// Add routes
const RouterConfig = {
  routes: [
    // MTPASA
    { path: '/electricity/nem/mtpasa', component: EstimatedUnservedEnergy, meta: { mtpasa: true } },
    { path: '/electricity/nem/mtpasa/mtpasa-fig2a', component: DistributionOfUnservedEnergy, meta: { mtpasa: true } },
    { path: '/electricity/nem/mtpasa/mtpasa-fig2b', component: UnservedEnergyEvents, meta: { mtpasa: true } },
    { path: '/electricity/nem/mtpasa/mtpasa-fig2c', component: MonthlyUnservedEnergy, meta: { mtpasa: true } },
    { path: '/electricity/nem/mtpasa/mtpasa-fig3', component: SeverityAndFrequencyOfUnservedEnergy, meta: { mtpasa: true } },
    { path: '/electricity/nem/mtpasa/mtpasa-fig4a', component: SupplyAndDemandBreakdown, meta: { mtpasa: true } },
    { path: '/electricity/nem/mtpasa/mtpasa-fig5', component: InterconnectorCapacity, meta: { mtpasa: true } },

    // Electricity
    { path: '/electricity/dashboard', component: ElectricityDashboard, meta: { title: 'Electricity Overview' } },
    { path: '/electricity/fpp/cost-rate', component: FppCostRate, meta: { title: 'FPP Cost Rate' } },
    { path: '/electricity/fpp/fcas-summary', component: FppFcasSummary, meta: { title: 'FPP FCAS Summary' } },
    { path: '/electricity/fpp/frequency-measure', component: FppFrequencyMeasure, meta: { title: 'FPP Frequency Measure' } },
    { path: '/electricity/fpp/historical-performance-and-dcf', component: FppHistoricalPerformanceAndDcf, meta: { title: 'FPP Historical Performance And DCF' } },
    { path: '/electricity/fpp/rcr-and-usage', component: FppRcrAndUsage, meta: { title: 'Fpp RCR And Usage' } },
    { path: '/electricity/fpp/residual', component: FppResidual, meta: { title: 'FPP Residual' } },
    { path: '/electricity/nem/price-and-demand', component: NemPriceAndDemand, meta: { title: 'NEM Price and Demand' } },
    { path: '/electricity/nem/cumulative-price', component: CumulativePrice, meta: { title: 'NEM Cumulative Price' } },
    { path: '/electricity/nem/aggregated-price-and-demand-files', component: NemAggregatedPriceAndDemandFiles, meta: { title: 'NEM Aggregated Price and Demand' } },
    { path: '/electricity/nem/average-price-tables', component: NemAveragePriceTables, meta: { title: 'NEM Average Price' } },
    { path: '/electricity/nem/dispatch-overview', component: NemDispatchOverview, meta: { title: 'NEM Dispatch Overview' } },
    { path: '/electricity/nem/fuel-mix', component: NemFuelMix, meta: { title: 'NEM Fuel Mix' } },
    { path: '/electricity/der/der-sites', component: DerSites, meta: { title: 'DER Sites' } },
    { path: '/electricity/nem/renewable-penetration', component: NemRenewablePenetration, meta: { title: 'NEM Renewable Penetration' } },
    // Gas
    { path: '/gas/dashboard', component: GasDashboard, meta: { title: 'Gas Overview' } }
  ]
};

Vue.filter('formatDate', (value: any, dateFormat?: string) => {
  return formatDate(value, dateFormat);
});

const router = new VueRouter(RouterConfig);
Vue.use(VueRouter);

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title)
    document.title = to.meta.title;
  next();
});

new Vue({
  // Root vue element
  el: '#root',
  // Register root level router
  router: router,
  // Register local components
  components: {
    App
  }
});




// WEBPACK FOOTER //
// src/main.ts